import { useEffect } from "react";
import { useSearchParams } from 'react-router-dom';


function StripeAddAccountSuccess() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    try {
      const body = document.querySelector("body");
      body.classList.add("no-header", "no-footer");
    } catch (err) {
      console.error(err);
    }
  }, []);
  function handleGoToApp(event){
    event.preventDefault();
    const data = {
      accountId: searchParams.get('accountId'),
      userId: searchParams.get('userId')
    };
    const appData = { action: 'stripe-add-account-success', data: data};
    window.ReactNativeWebView?.postMessage(JSON.stringify(appData));
  }
  return (
    <main>
      <section className="privacy-policy banner-scetion-padding py-5">
        <div className="container">
          <h1 className="heading-1" style={{fontSize: '40px', lineHeight: '40px'}}>Success</h1>
        </div>
      </section>
      <section className="d-block">
        <div className="container">
          <div className="time-update mb-4 text-center">
            <div className="action-animation my-4">
              <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                <circle className="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1" />
                <polyline className="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 " />
              </svg>
              <p className="success mb-0">Oh Yeah!</p>
            </div>
            <h2 style={{fontSize: '28px', lineHeight: '30px'}}>Yup, your account is successfully configured.</h2>
            <a href="/" onClick={handleGoToApp}  className="btn btn-black mt-4">Go to app</a>
          </div>
        </div>
      </section>
    </main>
  );
}

export default StripeAddAccountSuccess;
